module.exports = __webpack_public_path__ + "images/landing/video-previews/looking_for_house_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/looking_for_house_2x.jpg
// module id = R7d8
// module chunks = 1